import * as React from 'react';
import { translate } from 'react-i18next';
import { IPortalSectionProps } from 'models/portal/page/portalpagesection';
import * as c from 'models/constants';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { browserHistory } from 'react-router';

interface IProps extends IPortalSectionProps {
	t?: (key: string, options?: any) => string;
	linkToMagazine?: string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType9 extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.handleNavigate = this.handleNavigate.bind(this);
	}

	private handleNavigate(redirectPath: string) {
		if (redirectPath) {
			browserHistory.push(redirectPath);
		}
	}

	private renderBox(itemIndex: number) {
		const { section } = this.props;
		const imageUrl = section.items[0].elements[0]
			? (section.items[itemIndex].elements[0] as ISectionImageElement).imageUrl
			: undefined;
		const label = section.items[0].elements[6]
			? (section.items[itemIndex].elements[6] as ISectionTextElement).text
			: '';
		const redirectUrl =
			section.items[itemIndex].elements[1] && (section.items[0].elements[1] as ISectionTextElement).redirectUrl;
		const title = section.items[itemIndex].elements[1] && (section.items[0].elements[1] as ISectionTextElement).text;

		return (
			<div key={itemIndex}>
				<div
					style={{ backgroundImage: `url(${imageUrl})` }}
					className="pointer"
					onClick={() => this.handleNavigate(redirectUrl)}
				>
					{label.length ? (
						<div className="label">
							<p className="p12 white">{label.toUpperCase()}</p>
						</div>
					) : null}
				</div>
				<p>{title}</p>
			</div>
		);
	}

	public render() {
		return (
			<div className="row">
				<div className="col-lg-12">
					<div className="portalPageSectionType9 d-flex">
						{this.renderBox(0)}
						{this.renderBox(1)}
						{this.renderBox(2)}
					</div>
				</div>
			</div>
		);
	}
}

export { ViewType9 };
